import React from 'react';
import { motion } from 'framer-motion';
import LotusLogo from './LotusLogo';

const Hero = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="top" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* subtle grain */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
        backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/></filter><rect width='200' height='200' filter='url(%23n)' opacity='0.6'/></svg>\")",
      }} />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="mb-8"
        >
          <LotusLogo className="w-28 h-28 md:w-36 md:h-36 mx-auto" />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4 }}
          className="text-white font-light tracking-[0.2em] md:tracking-[0.3em] leading-tight"
          style={{
            fontFamily: "'Josefin Sans', sans-serif",
            fontSize: 'clamp(2rem, 6vw, 4.5rem)',
          }}
        >
          BLISSFULL MOBILE SPA
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="mt-6 md:mt-8 text-white/95 tracking-[0.25em] text-sm md:text-base font-light"
          style={{ fontFamily: "'Josefin Sans', sans-serif" }}
        >
          WHERE JOY MEETS BLISS IN EVERY MASSAGE
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.9 }}
          className="mt-12 md:mt-16 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6"
        >
          <button
            onClick={() => scrollTo('#contact')}
            className="group px-8 py-3.5 rounded-full border border-white/70 text-white text-xs md:text-sm tracking-[0.25em] font-light bg-white/5 backdrop-blur-sm hover:bg-white hover:text-rose-500 transition-all duration-500"
            style={{ fontFamily: "'Josefin Sans', sans-serif" }}
          >
            I NEED A MASSAGE!
          </button>
          <button
            onClick={() => scrollTo('#price-list')}
            className="group px-8 py-3.5 rounded-full border border-white/70 text-white text-xs md:text-sm tracking-[0.25em] font-light bg-white/5 backdrop-blur-sm hover:bg-white hover:text-rose-500 transition-all duration-500"
            style={{ fontFamily: "'Josefin Sans', sans-serif" }}
          >
            HOW MUCH IS IT?
          </button>
        </motion.div>
      </div>

      {/* Scroll cue */}
      <motion.div
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/70 text-xs tracking-[0.3em]"
        style={{ fontFamily: "'Josefin Sans', sans-serif" }}
      >
        SCROLL
      </motion.div>
    </section>
  );
};

export default Hero;
